import { createApiSlice } from 'app/createApiSlice'
import { API_CONFIGURATIONS } from 'utils/apiList'

export const configurationsListApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'configurationsList/api',
  endpoints(builder) {
    return {
      fetchConfigurations: builder.query({
        query() {
          return {
            url: API_CONFIGURATIONS,
          }
        },
      }),
      addConfiguration: builder.mutation({
        query(payload) {
          return {
            url: API_CONFIGURATIONS,
            method: 'POST',
            body: payload,
          }
        },
      }),
    }
  },
})

export const {
  useFetchConfigurationsQuery,
  useLazyFetchConfigurationsQuery,
  useAddConfigurationMutation,
} = configurationsListApiSlice
